/**
 * Backend API base for axios.
 * - `REACT_APP_BACKEND_URL` defined → normalized base + `/api` (see below).
 * - Otherwise → `/api` (same-origin or craco dev proxy).
 *
 * `REACT_APP_BACKEND_URL` may be `http://host:8000` or already `http://host:8000/api` — both work.
 */
export function getApiRoot() {
  let backendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
  if (!backendUrl) return "/api";
  if (/\/api$/i.test(backendUrl)) return backendUrl;
  return `${backendUrl}/api`;
}

export const API = getApiRoot();
